import { render, staticRenderFns } from "./PlanLimitWarningModal.vue?vue&type=template&id=60dcf158&scoped=true"
import script from "./PlanLimitWarningModal.vue?vue&type=script&lang=js"
export * from "./PlanLimitWarningModal.vue?vue&type=script&lang=js"
import style0 from "./PlanLimitWarningModal.vue?vue&type=style&index=0&id=60dcf158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dcf158",
  null
  
)

export default component.exports